import {
  Puzzle,
  Calendar,
  CreditCard,
  Users,
  Video,
  Settings,
  MessageCircle,
  BookOpen,
  LineChart,
  GraduationCap,
  LayoutTemplate,
  Radio,
  Send,
  FileDown,
  DollarSign,
  Youtube,
  MessagesSquare,
  Package,
  Presentation,
  Disc3,
  Sparkles,
  Layers,
} from "lucide-react";
import { SiDiscord } from "react-icons/si";
import React from "react";

const defaultIcon = <Puzzle className="h-6 w-6" />;

const slugRegistry: Record<string, React.ReactNode> = {
  "file-down": <FileDown className="h-6 w-6" />,
};

const registry: Record<string, React.ReactNode> = {
  COACHES: <GraduationCap className="h-6 w-6" />,
  COLLECTIONS: <Layers className="h-6 w-6" />,
  DISCORD_INTEGRATION: <SiDiscord className="h-6 w-6" />,
  LANDING_PAGE: <LayoutTemplate className="h-6 w-6" />,
  LIVE_STREAM: <Radio className="h-6 w-6" />,
  POSTS: <Send className="h-6 w-6" />,
  RESOURCES: slugRegistry["file-down"] ?? defaultIcon,
  SUBSCRIPTIONS: <DollarSign className="h-6 w-6" />,
  VIDEO_EMBEDS: <Youtube className="h-6 w-6" />,
  THREADS: <MessagesSquare className="h-6 w-6" />,
  VIDEO_UPLOADS: <Video className="h-6 w-6" />,
  EVENTS: <Calendar className="h-6 w-6" />,
  PAYMENTS: <CreditCard className="h-6 w-6" />,
  MEMBERS: <Users className="h-6 w-6" />,
  PAGES: <BookOpen className="h-6 w-6" />,
  ANALYTICS: <LineChart className="h-6 w-6" />,
  MESSAGING: <MessageCircle className="h-6 w-6" />,
  SETTINGS: <Settings className="h-6 w-6" />,
  // Requested updates
  CHANNELS: <Users className="h-6 w-6" />,
  COURSES: <Presentation className="h-6 w-6" />,
  SAMPLE_PACKS: <Package className="h-6 w-6" />,
  TRACK_FEEDBACK: <Disc3 className="h-6 w-6" />,
  ONBOARDING: <Sparkles className="h-6 w-6" />,
  ELEVATE_STORE: (
    <span className="flex h-6 w-6 items-center justify-center leading-none">
      {/* Light mode: dark icon */}
      <img
        src="/trackstack-icon-dark.png"
        alt="Store"
        className="block h-6 w-6 object-contain object-center dark:hidden"
        width={24}
        height={24}
      />
      {/* Dark mode: light logo */}
      <img
        src="/trackstack-logo-light.png"
        alt="Store"
        className="hidden h-6 w-6 object-contain object-center dark:block"
        width={24}
        height={24}
      />
    </span>
  ),
};

export function getModuleIconForKey(key?: string | null): React.ReactNode {
  if (!key) return defaultIcon;
  return registry[key] ?? defaultIcon;
}

export function getModuleIconForSlug(slug?: string | null): React.ReactNode {
  if (!slug) return defaultIcon;
  return slugRegistry[slug] ?? defaultIcon;
}
